// extracted by mini-css-extract-plugin
module.exports = {"rewardCodeView":"RewardCodeView_rewardCodeView__2Etlh","spin":"RewardCodeView_spin__ATK-8","transition-opacity":"RewardCodeView_transition-opacity__2BEeo"};